"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./Spinner.css");
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = __importDefault(require("classnames"));
function Spinner(_a) {
    var _b = _a.startShow, startShow = _b === void 0 ? false : _b, _c = _a.startLabel, startLabel = _c === void 0 ? '' : _c, _d = _a.startLabelDelay, startLabelDelay = _d === void 0 ? 0 : _d;
    var timer = react_1.useRef();
    var _e = __read(react_1.useState({ show: startShow, label: startLabel, labelDelay: startLabelDelay }), 2), state = _e[0], setState = _e[1];
    var _f = __read(react_1.useState(false), 2), showLabel = _f[0], setShowLabel = _f[1];
    react_1.useEffect(function () {
        window.addEventListener('updateSpinner', onUpdateSpinner, true);
        return function () {
            window.removeEventListener('updateSpinner', onUpdateSpinner, true);
        };
    }, [state]);
    var onUpdateSpinner = function (e) {
        var eventProps = e.detail;
        var updatedState = __assign(__assign({}, state), eventProps);
        setState(function (prevState) { return (__assign(__assign({}, prevState), eventProps)); });
        if (updatedState.show && eventProps.label)
            setShowLabel(true);
    };
    var onEnter = react_1.useCallback(function () {
        if (state.label) {
            if (state.labelDelay > 0) {
                timer.current = setTimeout(function () {
                    setShowLabel(true);
                }, state.labelDelay);
            }
            else {
                setShowLabel(true);
            }
        }
    }, []);
    var onExit = react_1.useCallback(function () {
        window.clearTimeout(timer.current);
        setShowLabel(false);
    }, []);
    var onExited = react_1.useCallback(function () {
        setState(function (prevState) { return (__assign(__assign({}, prevState), { label: startLabel })); });
    }, []);
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: state.show, timeout: 300, classNames: "Spinner", onEnter: onEnter, onExit: onExit, onExited: onExited, appear: true, unmountOnExit: true },
        react_1.default.createElement("div", { className: "Spinner", role: 'alert', "aria-label": state.show ? 'loading' : 'loading complete' },
            react_1.default.createElement("div", { className: 'Spinner_icon' },
                react_1.default.createElement("svg", { className: 'Spinner_svg', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 80" },
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval1' },
                        react_1.default.createElement("path", { d: "M40,20a3,3,0,0,1-3-3V3a3,3,0,1,1,6,0V17a3,3,0,0,1-3,3", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "40", y1: "20", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval2' },
                        react_1.default.createElement("path", { d: "M30,22.68a3,3,0,0,1-4.12-1.13l-7-12.06a3,3,0,1,1,5.19-3l7,12.06A3,3,0,0,1,30,22.68", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "30", y1: "22.68", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval1' },
                        react_1.default.createElement("path", { d: "M22.68,30a3,3,0,0,1-4.13,1.08l-12.07-7a3,3,0,1,1,3-5.19l12.07,7A3,3,0,0,1,22.68,30", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "22.68", y1: "30", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval2' },
                        react_1.default.createElement("path", { d: "M20,40a3,3,0,0,1-3,3H3a3,3,0,1,1,0-6H17a3,3,0,0,1,3,3", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "20", y1: "40", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval1' },
                        react_1.default.createElement("path", { d: "M22.68,50a3,3,0,0,1-1.13,4.12l-12.07,7a3,3,0,1,1-3-5.19l12.07-7A3,3,0,0,1,22.68,50", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "22.68", y1: "50", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval2' },
                        react_1.default.createElement("path", { d: "M30,57.32a3,3,0,0,1,1.08,4.13l-7,12.06a3,3,0,1,1-5.19-3l7-12.06A3,3,0,0,1,30,57.32", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "30", y1: "57.32", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval1' },
                        react_1.default.createElement("path", { d: "M40,60a3,3,0,0,1,3,3V77a3,3,0,1,1-6,0V63a3,3,0,0,1,3-3", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "40", y1: "60", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval2' },
                        react_1.default.createElement("path", { d: "M50,57.32a3,3,0,0,1,4.11,1.13l7,12.06a3,3,0,1,1-5.2,3l-7-12.06A3,3,0,0,1,50,57.32", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "50", y1: "57.32", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval1' },
                        react_1.default.createElement("path", { d: "M57.32,50a3,3,0,0,1,4.13-1.08l12.06,7a3,3,0,1,1-3,5.19l-12.06-7A3,3,0,0,1,57.32,50", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "57.32", y1: "50", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval2' },
                        react_1.default.createElement("path", { d: "M60,40a3,3,0,0,1,3-3H77a3,3,0,1,1,0,6H63a3,3,0,0,1-3-3", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "60", y1: "40", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval1' },
                        react_1.default.createElement("path", { d: "M57.32,30a3,3,0,0,1,1.12-4.12l12.07-7a3,3,0,1,1,3,5.19l-12.07,7A3,3,0,0,1,57.32,30", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "57.32", y1: "30", x2: "40", y2: "40", className: 'Spinner_line' })),
                    react_1.default.createElement("g", { className: 'Spinner_interval Spinner_interval2' },
                        react_1.default.createElement("path", { d: "M50,22.68a3,3,0,0,1-1.08-4.13l7-12.06a3,3,0,1,1,5.2,3l-7,12.06A3,3,0,0,1,50,22.68", className: 'Spinner_fill' }),
                        react_1.default.createElement("line", { x1: "50", y1: "22.68", x2: "40", y2: "40", className: 'Spinner_line' })))),
            react_1.default.createElement("span", { className: classnames_1.default('Spinner_label', {
                    'Spinner_label-show': showLabel,
                }) }, state.label))));
}
exports.Spinner = Spinner;
/** Update Spinner from anywhere in the dom */
exports.updateSpinner = function (e) {
    window.dispatchEvent(new CustomEvent('updateSpinner', {
        detail: e,
    }));
};
/** Update Spinner after delay */
exports.updateSpinnerWithDelay = function (delay, e, cb) {
    var seqItem = { delay: delay, event: e };
    var tm = setTimeout(function () {
        exports.updateSpinner(e);
        if (cb)
            cb(seqItem);
    }, delay * 1000);
    return function () { return clearTimeout(tm); };
};
/** Hook: Update Spinner in a sequence of time intervals */
exports.useUpdateSpinnerWithSequence = function () {
    var cancelSpinnerEventSequenceRef = react_1.useRef();
    var count = react_1.useRef(0);
    var sequence = react_1.useRef([]);
    var onUpdateSpinnerWithDelay = function (seqItem) {
        var prevSeqItem = sequence.current[count.current];
        if (prevSeqItem.callback)
            prevSeqItem.callback(seqItem);
        count.current++;
        if (count.current < sequence.current.length) {
            var nextSeqItem = sequence.current[count.current];
            cancelSpinnerEventSequenceRef.current = exports.updateSpinnerWithDelay(nextSeqItem.delay, nextSeqItem.event, onUpdateSpinnerWithDelay);
        }
        else {
            count.current = 0;
        }
    };
    var startSpinnerEventSequence = function (seq) {
        //update each item with difference from previous delay
        sequence.current = seq.map(function (item, i) {
            return i > 0 ? __assign(__assign({}, item), { delay: item.delay - seq[i - 1].delay }) : item;
        });
        var startSeqItem = sequence.current[count.current];
        cancelSpinnerEventSequenceRef.current = exports.updateSpinnerWithDelay(startSeqItem.delay, startSeqItem.event, onUpdateSpinnerWithDelay);
    };
    var cancelSpinnerEventSequence = function () {
        count.current = 0;
        if (cancelSpinnerEventSequenceRef.current)
            cancelSpinnerEventSequenceRef.current();
    };
    return [startSpinnerEventSequence, cancelSpinnerEventSequence];
};
